export const typeScale = {
	headerOne: '3.052rem',
	headerTwo: '2.441rem',
	headerThree: '1.953rem',
	headerFour: '1.563rem',
	headerFive: '1.25rem',
	paragraph: '1rem',
	small: '0.8rem',
	smallest: '0.64rem',
};
